import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SaveGamesWidgetHeaderBox} from "./boxes/save-games-widget-header.box";

export class SaveGamesWidgetHeaderComponent extends OrbitComponent<{}> {

    private async _onClick() {
        this.services.games.showAllSavedGamesDrawer();
        (await this.services.userMenu).closeMenu();
    }

    render() {

        const RightArrowIcon = this.services.theme.currentTheme.icons.rightArrowIcon;
        const SavedGamesIcon = this.services.theme.currentTheme.icons.saveGameIcon;

        return (
            <SaveGamesWidgetHeaderBox className={"cy-save-games-widget-header"}>
                <span>
                    <SavedGamesIcon size={2}/>
                </span>
                <span>
                    {this.services.translation.translate("MY_SAVED_GAMES")}
                </span>
                <span onClick={() => this._onClick()}>
                    {this.services.translation.translate("ALL")}
                    <RightArrowIcon size={1.5}/>
                </span>
            </SaveGamesWidgetHeaderBox>
        );
    }
}
